import cx from 'classnames'
import type { ComponentProps } from 'react'

import { Button } from '../../actions/button/Button'
import { IconButton } from '../../actions/iconButton/IconButton'
import { Dropdown } from '../dropdown/Dropdown'
import type { Icon } from '../icon/Icon'

type ButtonProps = ComponentProps<typeof Button>
type IconName = ComponentProps<typeof Icon>['name']
type DropdownItems = ComponentProps<typeof Dropdown>['items']

type Props = {
  actions: ({ key: string } & Pick<
    ButtonProps,
    'disabled' | 'isLoading' | 'isDanger'
  > &
    (
      | {
          onClick: NonNullable<ButtonProps['onClick']>
          items?: never
        }
      | {
          onClick?: never
          items: DropdownItems
        }
    ) &
    (
      | {
          label?: never
          iconName: IconName
          tip?: string
        }
      | (Pick<ButtonProps, 'startIcon' | 'endIcon'> & {
          label: string
          iconName?: never
          tip?: never
        })
    ))[]
  className?: string
}

export const CardActions = ({ actions, className }: Props) => (
  <div className={cx('ms-auto -me-1.5 -my-1.5 flex items-center', className)}>
    {actions.map(({ label, iconName, key, tip, items, ...buttonProps }) => {
      const element = iconName ? (
        <IconButton key={key} iconName={iconName} tip={tip} {...buttonProps} />
      ) : (
        <Button key={key} variant="discreet" {...buttonProps}>
          {label}
        </Button>
      )

      return items ? (
        <Dropdown key={key} element={element} items={items} />
      ) : (
        element
      )
    })}
  </div>
)
